export const SupportPanelEvents = {
    redirectListPage: 'he-support-request-redirect',
    ticketCreation: 'he-support-ticket-created',
    supportPanelShow: 'he-support-panel-show',
    supportPanelHide: 'he-support-panel-hide'
}